/**
 * Cookbook Dropdowns
 */

import initCTADropdown from '../../components/cta-dropdown';

document.addEventListener( 'DOMContentLoaded', ( ) => {
	const popups = document.querySelectorAll( '.overview-popup-box.popup' );
	const popupCloseLinks = document.querySelectorAll( '.overview-popup-box .popup-close' );
	if ( ! popups ) {
		return;
	}

	// Reset CTA Form when dropdown is closed.
	const resetCTAForm = ( form ) => {
		let defaults = form.querySelectorAll( '.nice-select .current' );

		// loop over defaults
		defaults.forEach( ( option, index ) => {
			// Reset dropdowns after modal closes.
			let defaultText = form.querySelectorAll( '.nice-select .option:first-child' );
			if ( defaultText[ index ].innerText === option.innerText ) {
				return;
			}

			option.innerHTML = defaultText[ index ].innerText;
		} );

		// Reset visible dropdowns.
		let storeDropdowns = form.querySelectorAll( '.nice-select.store-dropdown' );
		storeDropdowns.forEach( ( storeDropdown ) => {
			if ( storeDropdown.classList.contains( '!hidden' ) ) {
				return;
			}

			storeDropdown.classList.add( '!hidden' );
		} );

		// Anything with *-empty is our default value to show.
		let defaultStoreDropdown = form.querySelector( 'div[class*="-empty"]' );
		if ( ! defaultStoreDropdown ) {
			return;
		}
		defaultStoreDropdown.classList.remove( '!hidden' );

		let resetSelectedOptions = form.querySelectorAll( '.nice-select .selected' );
		// loop over defaults
		resetSelectedOptions.forEach( ( option, index ) => {
			// Skip the first index since it'll always be our default.
			if ( index === 0 ) {
				return;
			}

			option.classList.remove( 'selected' );
		} );

		// Reset error messages.
		const errorMessages = document.querySelectorAll( '#rte-cookbook-error' );
		errorMessages.forEach( ( errorMessage ) => {
			if ( errorMessage.classList.contains( 'flex' ) ) {
				errorMessage.classList.add( 'hidden' );
				errorMessage.classList.remove( 'flex' );
			}
		} );
	};

	const closeOverviewPopup = ( element ) => {
		resetCTAForm( element );
	};

	// Function to close all popups
	const closeOverviewPopups = () => {
		popups.forEach( ( el ) => {
			closeOverviewPopup( el );
		} );
	};

	const handleClick = () => {
		// Close the popup when the "Close" button is clicked
		popupCloseLinks.forEach( ( element ) => {
			element.addEventListener( 'click', function ( event ) {
				event.preventDefault();
				closeOverviewPopup( element?.closest( '.popup' ) );
			} );
		} );

		// Close the popup when clicking outside of it
		document.addEventListener( 'click', function ( event ) {
			if ( ! event.target.closest( '.popup-container' ) && ! event.target.closest( '.popup-link' ) ) {
				closeOverviewPopups();
			}
		} );

		// Close the popup when pressing the "Esc" key
		document.addEventListener( 'keydown', function ( event ) {
			if ( event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27 ) {
				closeOverviewPopups();
			}
		} );
	};

	initCTADropdown();
	handleClick();
} );

// Enable HMR
if ( module.hot ) {
	module.hot.accept();
}
